import type { Delivery } from '@/types/delivery'
import { httpClient } from '@/utils/request'

export interface DeliveryFile {
  file_name: string
  file_size: number
  file_url: string
}

export interface DeliveryForm {
  description: string
  files?: DeliveryFile[]
}

enum Api {
  Deliveries = '/deliveries',
  TaskDeliveries = '/tasks',
}

/**
 * 获取任务交付物列表
 * RESTful: GET /tasks/{id}/deliveries
 */
export function getTaskDeliveries(id: string | number) {
  return httpClient.get<Delivery[]>(`${Api.TaskDeliveries}/${id}/deliveries`)
}

/**
 * 提交交付物
 * RESTful: POST /tasks/{id}/deliveries
 */
export function submitDelivery(id: string | number, data: DeliveryForm) {
  return httpClient.post<Delivery>(`${Api.TaskDeliveries}/${id}/deliveries`, data)
}

/**
 * 接受验收
 * RESTful: POST /deliveries/{id}/accept
 */
export function acceptDelivery(id: string | number) {
  return httpClient.post<Delivery>(`${Api.Deliveries}/${id}/accept`)
}

/**
 * 拒绝验收
 * RESTful: POST /deliveries/{id}/reject
 */
export function rejectDelivery(id: string | number, reason: string) {
  return httpClient.post<Delivery>(`${Api.Deliveries}/${id}/reject`, { reason })
}
